export default "__VITE_ASSET__b1hsOFmg__"